import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    defaultButtons: new Map(),
    list: new Map(),
    initialized: false
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FHE__INIT_NOTIFICATIONS':
            return core.setNotifications(state, action.notifications);
        case 'FHE__SET_NOTIFICATIONDETAILS':
            return core.setNotificationDetails(state, action.notification);
        case 'FHE__UPDATE_NOTIFICATION':
            return core.updateNotificationDetails(state, action.notification);
        case 'FHE__ADD_NOTIFICATION':
            return core.addNotification(state, action.notificationId, action.notification);
        case 'FHE__SET_DEFAULT_NOTIFICATIONS_BUTTONS':
            return core.setDefaultNotificationsButtons(state, action.buttons);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Notifications/reducer.js